module.exports = __webpack_public_path__ + "static/media/chat-team.779f37de.svg";